import * as React from "react";
import {CSSProperties} from "react";

// https://vectr.com/new
// https://svg2jsx.com/
// https://convertio.co/eps-svg/

export interface IConcreteIcon {
    style?: CSSProperties;
    className?: string;
}

export interface IGenericIcon extends IConcreteIcon {
    file: string;
    alt?: string;
    absolutePath?: boolean;
}

export const Icon = ({file, style, absolutePath = false, className = "", alt = ""}: IGenericIcon) => {
    if (!absolutePath && file[0] !== '/') {
        file = '/' + file;
    }

    return (
        <img src={`${!absolutePath ? process.env.REACT_APP_CDN_HOST : ''}${file}`} style={{display: 'block', ...style}} alt={alt} />
    );
};
